// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-3ctCf";
var _5 = "disabilities-7q9Mt";
var _6 = "disabilities_error-Ghc5d";
var _7 = "checkboxes-3XZNd";
var _8 = "disabilities__bottomText-oMZsq";
var _9 = "disabilities__text-16XQ9";
var _a = "disabilities__infoIcon-2dfWo";
var _b = "checkbox-3vyLt";
var _c = "checkbox_checked-1hwpS";
var _d = "checkbox_root-1MbeA";
var _e = "checkbox_disabled-KLomD";
var _f = "checkbox_label-gn95Q";
var _10 = "switchWrapper-36WI3";
var _11 = "icon-21K1J";
var _12 = "switchControl__errorText-1IUNo";
var _13 = "switch__root-_N9Aq";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "disabilities", _6 as "disabilities_error", _7 as "checkboxes", _8 as "disabilities__bottomText", _9 as "disabilities__text", _a as "disabilities__infoIcon", _b as "checkbox", _c as "checkbox_checked", _d as "checkbox_root", _e as "checkbox_disabled", _f as "checkbox_label", _10 as "switchWrapper", _11 as "icon", _12 as "switchControl__errorText", _13 as "switch__root" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "disabilities": _5, "disabilities_error": _6, "checkboxes": _7, "disabilities__bottomText": _8, "disabilities__text": _9, "disabilities__infoIcon": _a, "checkbox": _b, "checkbox_checked": _c, "checkbox_root": _d, "checkbox_disabled": _e, "checkbox_label": _f, "switchWrapper": _10, "icon": _11, "switchControl__errorText": _12, "switch__root": _13 }
